import api from "./api";
import {PianoFatturazioneStato} from "@/types";

class StatoPianificazioneManager {


    public stati = [
        {id: PianoFatturazioneStato.PIANIFICATO, text: 'Pianificato'},
        {id: PianoFatturazioneStato.DA_FATTURARE, text: 'Da Fatturare'},
        {id: PianoFatturazioneStato.FATTURATO, text: 'Fatturato'}
    ];

    statiPianificazione(config?: any) {
        return Promise.resolve({
            data: this.stati
        });
    }

    statoPianificazione(id: number | string) {
        const el = this.stati.find(el=> el.id == id)
        return Promise.resolve({
            data: el
        });
    }

    list = this.statiPianificazione
    retrieve = this.statoPianificazione
}

const statoPianificazioneManager = new StatoPianificazioneManager()

export default statoPianificazioneManager
